<div class="dialog-container">
    <div class="se-dialog-header">
        <h3 class="se-dialog-title" translate>ImportPreviousData</h3>
    </div>

    <ag-grid-angular
        class="import-grid"
        [style.height.px]="gridHeight ?? 300"
        [rowData]="dialogData?.data"
        [gridOptions]="gridOptions"
        (gridReady)="onGridReady($event)"
        [modules]="agGridModuls"
        [theme]="agGridTheme"
    ></ag-grid-angular>

    <div class="se-dialog-actions">
        <button mat-button translate (click)="onClose()">Close</button>
    </div>
</div>
